import { Text } from '@common/components';

const HeadingText = ({ children }) =>
(
    <Text fontSize="16px" fontWeight="400" color="text">
    {children}
    </Text>
);

export default HeadingText;